module.exports = __webpack_public_path__ + "static/media/ascii-autostereogram.7aba442c.png";